import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';

import { map, catchError, switchMap } from 'rxjs/operators';
import { Observable, throwError, tap } from 'rxjs';
import { environment } from 'src/environments/environment.test';
import { Router } from '@angular/router';
import { GenerateInterceptService } from './generate-intercept.service';
import { KeycloakAuthResponse } from './interface/keycloak.auth';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: GenerateInterceptService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      request.url.match(environment.IDEMPIER_GATEWAY) ||
      request.url.match(environment.KEYCLOAK_USERS_ENDPOINT)
    ) {
      let userToken = sessionStorage.getItem('access_token');

      if (userToken) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${userToken}`,
          },
        });

        return next.handle(request).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.status === 401 && userToken) {
              return this.handleTokenExpired(request, next);
            }
            return throwError(() => err);
          }),
        );
      } else {
        return this.auth.getToken().pipe(
          switchMap((kcr: KeycloakAuthResponse) => {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${kcr.access_token}`,
              },
            });

            return next.handle(request).pipe(
              catchError((err: HttpErrorResponse) => {
                if (err.status === 401 && userToken) {
                  return this.handleTokenExpired(request, next);
                }
                return throwError(() => err);
              }),
            );
          }),
        );
      }
    } else {
      return next.handle(request);
    }
  }

  private handleTokenExpired(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return this.auth.refreshAccessToken().pipe(
      switchMap(() => {
        const newAccessToken = sessionStorage.getItem('access_token');
        return next.handle(this.addToken(request, newAccessToken!));
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.auth.logout();
        }
        return throwError(() => error);
      }),
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
